import axios from 'axios'
import {API_URL} from '../../../utils/consts'

export default {
    async searchMonetizations(page, perPage, state, closed = false) {
        try {
            let body = {page: page, perPage: perPage, state: state, closed: state === 'my' ? closed ? closed : false : false}
            const response = await axios.post(`${API_URL}/monetization/list`, body, {headers: {'content-type': 'application/json'}})
            return response && response.data
        } catch (e) {
            throw e
        }
    },
    async getRequestStatus(monetizationId) {
        try {
            const response = await axios.get(`${API_URL}/monetization/${monetizationId}/status`, {headers: {'content-type': 'application/json'}})
            if (response) {
                return response && response.data && response.data.record
            }
            return null
        } catch (e) {
            throw e
        }
    },
    async getDetail(monetizationId) {
        try {
            const response = await axios.get(`${API_URL}/monetization/${monetizationId}`, {headers: {'content-type': 'application/json'}})
            return response && response.data && response.data.record 
        } catch (e) {
            throw e
        }
    },
    async joinToMonetization(monetizationId, preEmption, coOwnership, contactMode) {
        try {
            const response = await axios.post(`${API_URL}/monetization/${monetizationId}/join`, {preEmption: preEmption, coOwnership: coOwnership, contactMode: contactMode}, {headers: {'content-type': 'application/json'}})
            return response && response.data && response.data.record
        } catch (e) {
            throw e
        }
    },
    async joinToTenderOrDirect(monetizationId, props) {
        try {
            const response = await axios.post(`${API_URL}/monetization/${monetizationId}/join`, props, {headers: {'content-type': 'application/json'}})
            return response && response.data && response.data.record
        } catch (e) {
            throw e
        }
    },
    async searchTours(monetizationId, page, perPage, orderBy = 'date', direction = 'desc') {
        try {
            const response = await axios.post(`${API_URL}/monetization/${monetizationId}/tour/list`, {page: page, perPage: perPage, orderBy: orderBy, direction: direction}, {headers: {'content-type': 'application/json'}})
            return response && response.data
        } catch (e) {
            throw e
        }
    },
    async removeParticipant(monetizationId) {
        try {
            const response = await axios.delete(`${API_URL}/monetization/${monetizationId}/participant`, {}, {headers: {'content-type': 'application/json'}})
            return response && response.data && response.data.record
        } catch (e) {
            throw e
        }
    },
    async getExpertOpinionsDocuments(monetizationId) {
        try {
            const response = await axios.get(`${API_URL}/monetization/${monetizationId}/expertOpinion`, {headers: {'content-type': 'application/json'}})
            return response && response.data && response.data.record
        } catch (e) {
            throw e
        }
    },
    async downloadExpertOpinionDocument(itemId, documentId) {
        try {
            const response = await axios.get(`${API_URL}/item/${itemId}/expertOpinion/${documentId}/document`, {headers: {'content-type': 'application/json'}, responseType: 'blob'})
            return response
        } catch (e) {
            throw e
        }
    }
}
